var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidingLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    viewBox: "0 0 48 48",
    height: 36,
    width: 36,
    className: "ability-icon createSvgIcon__Svg-sc-1l8xi8d-0 ldKivg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24 10-2 2.5V14l-1.5 1.5L17 15l-6-2 .5 2L0 13l6 5-5 1 4.5 2 4 .5L7 24l3.5-.5-1 4 5-2.5-.5 3.5 3-3 1.5 3 2.5-3 1.5 2L21 33l2-.5-1 2.5 1.5-1 .5 8 .5-8 1.5 1-1-2.5 2 .5-1.5-5.5 1.5-2 2.5 3 1.5-3 3 3-.5-3.5 5 2.5-1-4 3.5.5-2.5-2.5 4-.5 4.5-2-5-1 6-5-11.5 2 .5-2-6 2-3.5.5L26 14v-1.5L24 10Zm-1.5 3.5V12l1 1v1H23l-.5-.5Zm3 0V12l-1 1v1h.5l.5-.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidingLight);
export default __webpack_public_path__ + "static/media/guiding_light.dd8113e2.svg";
export { ForwardRef as ReactComponent };